import React, { useState } from 'react';
import { Button, CircularProgress } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';
import { useSnackbar } from 'notistack';
import { downloadDebtActPdf } from '../api';

interface DownloadActButtonProps {
  realEstateGuid: string;
  contractGuid: string;
  ownerGuid1c: string;
}

const DownloadActButton: React.FC<DownloadActButtonProps> = ({
  realEstateGuid,
  contractGuid,
  ownerGuid1c,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [pending, setPending] = useState(false);

  const handleDownload = () => {
    setPending(true);
    downloadDebtActPdf({ realEstateGuid, contractGuid, ownerGuid1c })
      .catch((error) => {
        enqueueSnackbar(
          error?.response?.data?.message || 'Ошибка формирования акта. Попробуйте позже',
          { variant: 'error' },
        );
      })
      .finally(() => setPending(false));
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={pending ? <CircularProgress size={16} color="inherit" /> : <GetApp />}
      onClick={handleDownload}
      disabled={pending}
    >
      Сформировать акт сверки
    </Button>
  );
};

export default DownloadActButton;
